import { useMemo } from 'react'
import type { IEntityFormSetting, FieldSettingsMap } from '../typings'

//TODO: sync this for Opp as well
// call once, pass as props?
export function useGetFieldActiveStates(
  settings: IEntityFormSetting[],
  hideOptional?: boolean,
) {
  return useMemo(() => {
    const map: FieldSettingsMap = new Map()

    settings.map((setting) => {
      const { fieldId, required, active } = setting
      const enabled = required || (active && !hideOptional)
      map.set(fieldId, [required, enabled])
    })

    return map
  }, [hideOptional, settings])
}
